<div class="modal-container popup-general modal-lg percent_25 row">

    <div class="modal-container-header col-12">
        <span> {{ 'gestion_vehiculos.popup.busquedaVehiculos' | translate}}</span>
        <span class="k-icon k-i-close" (click)="closeModal('vehicleSelectorForm',false)"></span>
    </div>

    <div class="modal-container-section col-12">

        <div class="row">

            <div class="col-3">
                <div class="form-group">
                    <label>{{ 'gestion_vehiculos.popup.family' | translate}} </label>
                    <select class="form-control form-control-sm" (change)="onChangeSilueta(family.value)" #family>
                        <option selected>{{ 'labels.seleccionar' | translate}}</option>
                        <option value="{{model.Famille}}" *ngFor="let model of dataFamilyAuto">{{ model?.FamilleAO }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-3" *ngIf="siluetaOption">
                <div class="form-group">
                    <label>{{ 'gestion_vehiculos.popup.silueta' | translate}} </label>
                    <select class="form-control form-control-sm" (change)="onChangeMotor(contour.value)" #contour>
                        <option value="" selected>{{ 'labels.seleccionar' | translate}}</option>
                        <option value="{{siluet.Silhouette}}" *ngFor="let siluet of dataSiluetaAuto">
                            {{ siluet?.SilhouetteAO }}</option>
                    </select>
                </div>
            </div>

            <div class="col-3" *ngIf="motorOption">
                <div class="form-group">
                    <label>{{ 'gestion_vehiculos.popup.motor' | translate}}</label>
                    <select class="form-control form-control-sm" (change)="onChangeTransmission(engine.value)" #engine>
                        <option value="" selected>{{ 'labels.seleccionar' | translate}}</option>
                        <option value="{{motor.Moteur}}" *ngFor="let motor of dataMotorAuto">{{ motor?.Motao }}</option>
                    </select>
                </div>
            </div>

            <div class="col-3" *ngIf="transmissionOption">
                <div class="form-group">
                    <label>{{ 'gestion_vehiculos.popup.transmisión' | translate}}</label>
                    <select class="form-control form-control-sm" (change)="onChangeLast(transmission.value)"
                        #transmission>
                        <option value="" selected>{{ 'labels.seleccionar' | translate}}</option>
                        <option value="{{transmission.Bv}}" *ngFor="let transmission of dataTransmission">
                            {{ transmission?.BvAO }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-3 cotenedor-datos">
                <kendo-grid *ngIf="!loading" (cellClick)="selectRow($event)" [data]="familyAuto[0].gridView"
                    [height]="330">
                    <kendo-grid-column *ngFor="let item of familyAuto[0].th;let i=index"
                        field="{{familyAuto[0].fields[i]}}" title="{{item}}">
                    </kendo-grid-column>
                </kendo-grid>
                <div class="kendo-loading " *ngIf="loading">
                    <span appCurrentColor [style.height.px]="330" class="k-icon k-i-loading big"></span>
                </div>
            </div>

        </div>

    </div>
</div>
